import { render, staticRenderFns } from "./home-layout.vue?vue&type=template&id=0f8b975e&scoped=true&"
import script from "./home-layout.vue?vue&type=script&lang=js&"
export * from "./home-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b975e",
  null
  
)

export default component.exports